import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";

function RegisterButton() {
	const history = useHistory();

	const handleClick = () => {
		history.push("/registrationsetup");
	};

	const { theme } = useContext(DiseaseGroupContext);

	return (
		<>
			<button
				onClick={handleClick}
				className={`mx-auto text-center text-white p-3 rounded-lg w-48 sm:w-64 text-xl block flex-shrink ${theme
					.button()
					.bg()}`}
			>
				Register...
			</button>
		</>
	);
}

export default RegisterButton;
